module.exports = __webpack_public_path__ + "img/Viewed.6fd91466.svg";